<template>
  <el-card class="box-card">
  <div style="padding:10px 10px 10px 10px">
    <div>
      <!-- <div class="class_3">选择美钥码</div> -->
  <div class="block" style="margin-top:20px;">
    <el-button class="selectButton" @click="selectQr()">{{selectQrDialogOption.selectQrButtonText}}</el-button>
    <el-date-picker class="dateButton" v-model="selectedDate1" type="daterange" align="right" placeholder="选择日期范围" :picker-options="pickerOptions1">
    </el-date-picker>
    <el-button class="countButton" type="success" @click="showCharts()">统计</el-button>
  </div>

    </div>
    <div style="margin-top:30px;border-top:1px solid #d1dbe5;padding-top:10px;">
      <div class="class_3">关键数据</div>
      <el-row>
      <el-col :span="8">
        <div class="class_2">扫描总数:</div>
        <div class="class_4">{{scanTotalNumber}}</div>
      </el-col>
      <el-col :span="8">
        <div class="class_2">用户总数:</div>
        <div class="class_4">{{userTotalNumber}}</div>
      </el-col>
      <el-col :span="8">
        <div class="class_2">今天扫描次数:</div>
        <div class="class_4">{{lastDayScanNumber}}</div>
      </el-col>
      </el-row>
    </div>
    <div style="margin-top:20px;border-top:1px solid #d1dbe5;padding-top:10px;">
      <el-row>
      <el-col :span="12">
        <div id="chartsArea1" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
        <myTable prop1="date" prop2="scanNumber" label1="日期" label2="扫描次数" prop3="userNumber" label3="活跃用户数" prop4="" label4="" width1="110" width2="100" width3="110" width4="110" :dataForTable="dataForTable1"></myTable>
      </el-col>
      </el-row>
    </div>
    <div style="margin-top:20px;border-top:1px solid #d1dbe5;padding-top:10px;">
      <el-row>
      <el-col :span="12">
        <div id="chartsArea0" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
        <myTable prop1="province" prop2="scanNumber" label1="省份" label2="扫描次数" prop3="userNumber" label3="活跃用户数" prop4="" label4="" width1="110" width2="100" width3="110" width4="110" :dataForTable="dataForTable0"></myTable>
      </el-col>
      </el-row>
    </div>

    <div style="margin-top:20px;border-top:1px solid #d1dbe5;padding-top:10px;">
      <el-row>
      <el-col :span="6">
        <div id="chartsArea3" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="6">
        <div id="chartsArea4" style="width:100%;height:500px;"></div>
      </el-col>
      <el-col :span="12">
  
        <myTable prop1="device" prop2="scanNumber" prop3="userNumber" prop4="" label1="设备" label2="扫描次数" label3="活跃用户数" label4="" width1="110" width2="100" width3="110" width4="110" :dataForTable="dataForTable3"></myTable>
      </el-col>
      </el-row>
    </div>
    <selectQrDialog :dialog="selectQrDialogOption"></selectQrDialog>
  </div>
  </el-card>
</template>


<script>
import echarts from 'echarts'
import 'echarts/map/js/china'
import myTable from './dataAnalysisTable.vue'
import $ from 'jquery'
import selectQrDialog from './selectedQrDialog.vue'
export default {
  components: {
    myTable,
    selectQrDialog
  },
  data () {
    return {
      scanTotalNumber: 0,
      lastDayScanNumber: 0,
      lastWeekScanNumber: 0,
      userTotalNumber: 0,
      selectedDate0: [new Date(new Date().getFullYear(), (new Date().getMonth() - 1), new Date().getDate()), new Date()],
      selectedDate1: [new Date(new Date().getFullYear(), (new Date().getMonth() - 1), new Date().getDate()), new Date()],
      selectedDate2: new Date(),
      selectedDate3: [new Date(new Date().getFullYear(), (new Date().getMonth() - 1), new Date().getDate()), new Date()],
      dataForTable0: [],
      dataForTable1: [],
      dataForTable2: [],
      dataForTable3: [],
      clickedNumber: 0,
      selectQrDialogOption: {
        seen: false,
        selectedQrId: 0,
        selectQrButtonText: '选择统计的美钥码'
      },
      pickerOptions0: { // 选择日期时候的快速选项
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pickerOptions1: { // 选择日期时候的快速选项
        shortcuts: [{
          text: '最近三天',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      pickerOptions2: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: '一周前',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      },
      options: [
        // 中国地图 0
        {
          title: {
            text: '美钥码扫描分布情况',
            subtext: '',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: ['扫描次数', '活跃用户数']
          },
          visualMap: {
            min: 0,
            max: 2500,
            left: 'left',
            top: 'bottom',
            text: ['高', '低'],
            calculable: true
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            itemSize: 50,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          series: [
            {
              name: '扫描次数',
              type: 'map',
              map: 'china',
              roam: false,
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: true
                }
              },
              data: []
            },
            {
              name: '活跃用户数',
              type: 'map',
              map: 'china',
              roam: false,
              label: {
                normal: {
                  show: true
                },
                emphasis: {
                  show: true
                }
              },
              data: []
            }
          ]
        },
        // 柱状图 1
        {
          title: {
            text: '美钥码扫描次数统计图',
            left: 'center'
          },
          color: ['#f44f4b'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            itemSize: 50,
            itemGap: 30,
            feature: {
              magicType: {
                type: ['line', 'bar']
              },
              saveAsImage: {}
            },
            right: 20
          },
          xAxis: [
            {
              type: 'category',
              data: [],
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '扫描次数',
              type: 'bar',
              barWidth: '60%',
              data: []
            }
          ]
        },
        // 2 折线图
        {
          title: {
            text: '美钥码扫描情况',
            subtext: '',
            left: 'center'
          },
          legend: {
            data: ['扫描次数', '活跃用户数'],
            left: 'right'
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            // left: 'left',
            itemSize: 40,
            itemGap: 30,
            feature: {
              magicType: {
                type: ['line', 'bar', 'stack', 'tiled']
              },
              saveAsImage: {}
            },
            right: 20
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '扫描次数',
              type: 'line',
              data: []
            },
            {
              name: '活跃用户数',
              type: 'line',
              data: []
            }
          ]
        },
        // 3 扇形图
        {
          title: {
            text: '',
            subtext: '',
            left: 'center'
          },
          color: ['#dddddd'],
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          toolbox: {
            show: true,
            orient: 'vertical',
            top: 'center',
            itemSize: 40,
            itemGap: 30,
            feature: {
              saveAsImage: {}
            },
            right: 20
          },
          series: [
            {
              name: '访问来源',
              type: 'pie',
              radius: '50%',
              center: ['50%', '60%'],
              data: [0],
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
      ]
    }
  },
  mounted () {
    const vm = this
    vm.initChart()
    if (vm.$route.query.qrid !== undefined) {
      vm.selectQrDialogOption.selectedQrId = vm.$route.query.qrid
      if (vm.$route.query.qrname === '') {
        vm.selectQrDialogOption.selectQrButtonText = '未命名'
      } else {
        vm.selectQrDialogOption.selectQrButtonText = vm.$route.query.qrname
      }
      this.showCharts()
    }
  },
  methods: {
    selectQr () {
      this.selectQrDialogOption.seen = true
      this.$router.push('/analysis/scan/labelid/all')
    },
    showCharts () {
      this.selectedDate0 = this.selectedDate1
      this.selectedDate3 = this.selectedDate1
      this.showChart(0)
      this.showChart(3)
      this.showChart(1)
    },
    getTitileData () {
      const vm = this
      $.ajax({
        type: 'GET',
        url: '/v1/charts/scanNumberOfOneQr',
        async: false,
        data: {
          qrid: vm.selectQrDialogOption.selectedQrId
        },
        dataType: 'json',
        success: function (response) {
          vm.scanTotalNumber = response.data
        }
      })
      $.ajax({
        type: 'GET',
        url: '/v1/charts/scanNumberOneDayOfOneQr',
        async: false,
        data: {
          qrid: vm.selectQrDialogOption.selectedQrId
        },
        dataType: 'json',
        success: function (response) {
          vm.lastDayScanNumber = response.data
        }
      })
      $.ajax({
        type: 'GET',
        url: '/v1/charts/userNumberOfOneQr',
        async: false,
        data: {
          qrid: vm.selectQrDialogOption.selectedQrId
        },
        dataType: 'json',
        success: function (response) {
          vm.userTotalNumber = response.data
        }
      })
    },
    initChart () {
      const vm = this
      vm.myChart0 = echarts.init(vm.$el.querySelector('#chartsArea0'))
      vm.myChart1 = echarts.init(vm.$el.querySelector('#chartsArea1'))
      // vm.myChart2 = echarts.init(vm.$el.querySelector('#chartsArea2'))
      vm.myChart3 = echarts.init(vm.$el.querySelector('#chartsArea3'))
      vm.myChart4 = echarts.init(vm.$el.querySelector('#chartsArea4'))
      vm.myChart0.setOption(vm.options[0])
      vm.myChart1.setOption(vm.options[2])
      // vm.myChart2.setOption(vm.options[1])
      vm.options[3].title.text = '扫描设备分布'
      vm.myChart3.setOption(vm.options[3])
      vm.options[3].title.text = '用户设备分布'
      vm.myChart4.setOption(vm.options[3])
    },
    showChart (val) {
      const vm = this
      if (vm.selectQrDialogOption.selectedQrId === 0) {
        vm.$message.warning('请选择要统计的美钥码')
      } else {
        let maxNumberOfMap = 5
        vm.getTitileData()
        if (val === 0) {
          let from = vm.selectedDate0[0].getFullYear() + '-' + (vm.selectedDate0[0].getMonth() + 1) + '-' + vm.selectedDate0[0].getDate()
          let to = vm.selectedDate0[1].getFullYear() + '-' + (vm.selectedDate0[1].getMonth() + 1) + '-' + vm.selectedDate0[1].getDate()
          vm.dataForTable0 = []
          vm.myChart0.showLoading()
          $.ajax({
            type: 'GET',
            url: '/v1/charts/countByProvinceAndDate',
            async: false,
            data: {
              qrid: vm.selectQrDialogOption.selectedQrId,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              vm.options[0].series[0].data = []
              for (let i = 0; i < response.data.length; i++) {
                let temp = { name: response.data[i].province, value: response.data[i].number }
                vm.options[0].series[0].data.push(temp)
                let find = false
                for (let j = 0; j < vm.dataForTable0.length; j++) {
                  if (vm.dataForTable0[j].province === response.data[i].province) {
                    find = true
                    vm.dataForTable0[j].scanNumber = response.data[i].number
                    if (vm.dataForTable0[j].userNumber !== 0 && vm.dataForTable0[j].scanNumber !== 0) {
                      vm.dataForTable0[j].calc = vm.dataForTable0[j].scanNumber / vm.dataForTable0[j].userNumber
                    } else {
                      vm.dataForTable0[j].calc = 0
                    }
                    break
                  }
                }
                if (find === false) {
                  temp = { province: response.data[i].province, scanNumber: response.data[i].number, userNumber: 0, calc: 0 }
                  vm.dataForTable0.push(temp)
                }
                if (Number(response.data[i].number) > maxNumberOfMap) {
                  maxNumberOfMap = Number(response.data[i].number)
                }
              }
              vm.options[0].visualMap.max = 2 * maxNumberOfMap
            }
          })
          $.ajax({
            type: 'GET',
            url: '/v1/charts/scanUsersDistribution',
            async: false,
            data: {
              qrid: vm.selectQrDialogOption.selectedQrId,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              vm.options[0].series[1].data = []
              for (let i = 0; i < response.data.length; i++) {
                let temp = { name: response.data[i].province, value: response.data[i].userNumber }
                vm.options[0].series[1].data.push(temp)
                let find = false
                for (let j = 0; j < vm.dataForTable0.length; j++) {
                  if (vm.dataForTable0[j].province === response.data[i].province) {
                    find = true
                    vm.dataForTable0[j].userNumber = response.data[i].userNumber
                    if (vm.dataForTable0[j].userNumber !== 0 && vm.dataForTable0[j].scanNumber !== 0) {
                      vm.dataForTable0[j].calc = vm.dataForTable0[j].scanNumber / vm.dataForTable0[j].userNumber
                    } else {
                      vm.dataForTable0[j].calc = 0
                    }
                    break
                  }
                }
                if (find === false) {
                  temp = { province: response.data[i].province, scanNumber: 0, userNumber: response.data[i].userNumber, calc: 0 }
                  vm.dataForTable0.push(temp)
                }
                if (Number(response.data[i].userNumber) > maxNumberOfMap) {
                  maxNumberOfMap = Number(response.data[i].userNumber)
                  // vm.options[0].visualMap.max = 20
                }
              }
              vm.options[0].visualMap.max = 2 * maxNumberOfMap
              vm.options[0].title.subtext = '美钥码:' + vm.selectQrDialogOption.selectQrButtonText + '(' + from + '至' + to + ')'
              vm.myChart0.hideLoading()
              vm.myChart0.setOption(vm.options[0], true)
            }
          })
        } else if (val === 1) {
          let from = vm.selectedDate1[0].getFullYear() + '-' + (vm.selectedDate1[0].getMonth() + 1) + '-' + vm.selectedDate1[0].getDate()
          let to = vm.selectedDate1[1].getFullYear() + '-' + (vm.selectedDate1[1].getMonth() + 1) + '-' + vm.selectedDate1[1].getDate()
          vm.myChart1.showLoading()
          $.ajax({
            type: 'GET',
            url: '/v1/charts/countByFewDays',
            async: false,
            data: {
              qrid: vm.selectQrDialogOption.selectedQrId,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              vm.options[2].series[0].data = []
              vm.options[2].series[1].data = []
              vm.options[2].xAxis.data = []
              vm.dataForTable1 = []
              let x = new Date(vm.selectedDate1[0])
              for (let i = 0; i < response.data.length / 2; i++) {
                vm.options[2].series[0].data.push(response.data[i * 2])
                vm.options[2].series[1].data.push(response.data[i * 2 + 1])
                let temp = x.getFullYear() + '-' + (x.getMonth() + 1) + '-' + x.getDate()
                vm.options[2].xAxis.data.push(temp)
                x.setDate(x.getDate() + 1)
                let temp3
                if (response.data[i * 2 + 1] !== 0) {
                  temp3 = response.data[i * 2] / response.data[i * 2 + 1]
                } else {
                  temp3 = 0
                }
                let temp2 = { date: temp, scanNumber: response.data[i * 2], userNumber: response.data[i * 2 + 1], calc: temp3.toFixed(2) }
                vm.dataForTable1.push(temp2)
              }
              vm.myChart1.hideLoading()
              vm.options[2].title.subtext = '美钥码:' + vm.selectQrDialogOption.selectQrButtonText + '(' + from + '至' + to + ')'
              vm.myChart1.setOption(vm.options[2], true)
            }
          })
        } else if (val === 2) {
          let date = vm.selectedDate2.getFullYear() + '-' + (vm.selectedDate2.getMonth() + 1) + '-' + vm.selectedDate2.getDate()
          vm.myChart2.showLoading()
          $.ajax({
            type: 'GET',
            url: '/v1/charts/countByOneDay',
            async: false,
            data: {
              id: vm.selectQrDialogOption.selectedQrId,
              date: date
            },
            dataType: 'json',
            success: function (response) {
              vm.options[1].series[0].data = []
              vm.options[1].xAxis[0].data = []
              vm.dataForTable2 = []
              let x = new Date(vm.selectedDate2)
              x.setHours(0)
              for (let i = 0; i < response.data.length; i++) {
                vm.options[1].series[0].data.push(response.data[i])
                let temp = (x.getMonth() + 1) + '-' + x.getDate() + ' ' + x.getHours() + ':00'
                vm.options[1].xAxis[0].data.push(temp)
                let temp2 = { hour: x.getHours() + ':00' + '-' + (x.getHours() + 1) + ':00', scanNumber: response.data[i] }
                vm.dataForTable2.push(temp2)
                x.setHours(x.getHours() + 1)
              }
              vm.options[1].title.subtext = '美钥码:' + vm.selectQrDialogOption.selectQrButtonText + '(' + date + ')'
              vm.myChart2.hideLoading()
              vm.myChart2.setOption(vm.options[1], true)
            }
          })
        } else if (val === 3) {
          let from = vm.selectedDate3[0].getFullYear() + '-' + (vm.selectedDate3[0].getMonth() + 1) + '-' + vm.selectedDate3[0].getDate()
          let to = vm.selectedDate3[1].getFullYear() + '-' + (vm.selectedDate3[1].getMonth() + 1) + '-' + vm.selectedDate3[1].getDate()
          vm.myChart3.showLoading()
          let allZero = true
          $.ajax({
            type: 'GET',
            url: '/v1/charts/countByOsAndDate',
            async: false,
            data: {
              qrid: vm.selectQrDialogOption.selectedQrId,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              vm.options[3].series[0].data = []
              vm.dataForTable3 = []
              for (let i = 0; i < response.data.length; i++) {
                let temp = { name: response.data[i].name, value: response.data[i].scanNumber }
                vm.options[3].series[0].data.push(temp)
                if (response.data[i].scanNumber !== 0) {
                  allZero = false
                }
                let find = false
                for (let j = 0; j < vm.dataForTable3.length; j++) {
                  if (vm.dataForTable3[j].device === response.data[i].name) {
                    find = true
                    vm.dataForTable3[j].scanNumber = response.data[i].scanNumber
                    if (vm.dataForTable3[j].userNumber !== 0 && vm.dataForTable3[j].scanNumber !== 0) {
                      vm.dataForTable3[j].calc = vm.dataForTable3[j].scanNumber / vm.dataForTable3[j].userNumber
                    }
                    break
                  }
                }
                if (find === false) {
                  temp = { device: response.data[i].name, userNumber: 0, scanNumber: response.data[i].scanNumber, calc: 0 }
                  vm.dataForTable3.push(temp)
                }
              }
              vm.options[3].title.text = '扫描设备分布'
              vm.options[3].title.subtext = '美钥码:' + vm.selectQrDialogOption.selectQrButtonText + '(' + from + '至' + to + ')'
              vm.myChart3.hideLoading()
              if (allZero === true) {
                vm.options[3].series[0].data.push(0)
                vm.options[3].color = ['#dddddd']
              } else {
                vm.options[3].color = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3']
              }
              vm.myChart3.setOption(vm.options[3], true)
            }
          })
          vm.myChart4.showLoading()
          allZero = true
          $.ajax({
            type: 'GET',
            url: '/v1/charts/countUserByOsAndDate',
            async: false,
            data: {
              qrid: vm.selectQrDialogOption.selectedQrId,
              from: from,
              to: to
            },
            dataType: 'json',
            success: function (response) {
              vm.options[3].series[0].data = []
              vm.dataForTable1 = []
              for (let i = 0; i < response.data.length; i++) {
                let temp = { name: response.data[i].name, value: response.data[i].userNumber }
                vm.options[3].series[0].data.push(temp)
                if (response.data[i].userNumber !== 0) {
                  allZero = false
                }
                let find = false
                for (let j = 0; j < vm.dataForTable3.length; j++) {
                  if (vm.dataForTable3[j].device === response.data[i].name) {
                    find = true
                    vm.dataForTable3[j].userNumber = response.data[i].userNumber
                    if (vm.dataForTable3[j].userNumber !== 0 && vm.dataForTable3[j].scanNumber !== 0) {
                      vm.dataForTable3[j].calc = vm.dataForTable3[j].scanNumber / vm.dataForTable3[j].userNumber
                    }
                    break
                  }
                }
                if (find === false) {
                  temp = { device: response.data[i].name, userNumber: response.data[i].userNumber, scanNumber: 0, calc: 0 }
                  vm.dataForTable3.push(temp)
                }
              }
              vm.options[3].title.text = '用户设备分布'
              vm.options[3].title.subtext = '美钥码:' + vm.selectQrDialogOption.selectQrButtonText + '(' + from + '至' + to + ')'
              vm.myChart4.hideLoading()
              if (allZero === true) {
                vm.options[3].series[0].data.push(0)
                vm.options[3].color = ['#dddddd']
              } else {
                vm.options[3].color = ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3']
              }
              vm.options[3].series[0].color = []
              vm.myChart4.setOption(vm.options[3], true)
            }
          })
        } else if (val === 4) {
          // TODO:
        }
      }
    }
  }
}
</script>

<style type="text/css">
.class_1 {
  font-size: 20px;
  color: rgb(244, 79, 75);
}

.class_2 {
  text-align: center;
  margin-top: 20px;
}

.class_3 {
  line-height: 20px;
  font-size: 24px;
}

.class_4 {
  text-align: center;
  line-height: 50px;
}
.selectButton {
  width: 20%;
  margin-left: 10%;
  border: 1px solid green;
}
.countButton {
  width: 20%;
}
.box-card {
  margin: 10px 15px;
}
</style>
